module.exports = __webpack_public_path__ + "img/facebook.1260c14a.svg";